export const SHOW_SCORECARD_REQUIRED_MODAL =
  'app/ScorecardRequiredModal/SHOW_SCORECARD_REQUIRED_MODAL';
export const HIDE_SCORECARD_REQUIRED_MODAL =
  'app/ScorecardRequiredModal/HIDE_SCORECARD_REQUIRED_MODAL';
